// extracted by mini-css-extract-plugin
export default {"scoresChartContainer":"styles_scoresChartContainer__w-W-W"};